<payee-chip-dropdown
  [selected]="value"
  [placeholder]="'Jogosultságok'"
  [displayWith]="displayRole"
  [(dropdownOpen)]="dropdownOpen"
  (removed)="removed()"
>
  <payee-form-field width="wide">
    <payee-autocomplete
      placeholder="Válassz jogosultságot"
      [formControl]="formControl"
      [options]="roleOptions"
      [displayWith]="displayRole"
    ></payee-autocomplete>
  </payee-form-field>
  <button
    payee-button
    color="primary"
    class="top-margin-10"
    width="wide"
    (click)="apply()"
  >
    Alkalmaz
  </button>
</payee-chip-dropdown>
